import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '../locales/en/translation.json';
import de from '../locales/de/translation.json';
import it from '../locales/it/translation.json';
import pl from '../locales/pl/translation.json';
import fr from '../locales/fr/translation.json';
import es from '../locales/es/translation.json';
import hu from '../locales/hu/translation.json';
import nl from '../locales/nl/translation.json';
import ru from '../locales/ru/translation.json';
import sl from '../locales/sl/translation.json';

// Howto translations
import enHowto from '../locales/en/howto.json';
import deHowto from '../locales/de/howto.json';
import itHowto from '../locales/it/howto.json';
import plHowto from '../locales/pl/howto.json';
import frHowto from '../locales/fr/howto.json';
import esHowto from '../locales/es/howto.json';
import huHowto from '../locales/hu/howto.json';
import nlHowto from '../locales/nl/howto.json';
import ruHowto from '../locales/ru/howto.json';
import slHowto from '../locales/sl/howto.json';

export const supportedLanguages = [
  { value: 'en', label: 'English' },
  { value: 'de', label: 'Deutsch' },
  { value: 'it', label: 'Italiano' },
  { value: 'pl', label: 'Polski' },
  { value: 'fr', label: 'Français' },
  { value: 'es', label: 'Español' }
];

// Add additional languages (including new locales added)
supportedLanguages.push(
  { value: 'hu', label: 'Magyar' },
  { value: 'nl', label: 'Nederlands' },
  { value: 'ru', label: 'Русский' },
  { value: 'sl', label: 'Slovenščina' }
);

const resources = {
  en: { translation: en, howto: enHowto },
  de: { translation: de, howto: deHowto },
  it: { translation: it, howto: itHowto },
  pl: { translation: pl, howto: plHowto },
  fr: { translation: fr, howto: frHowto },
  es: { translation: es, howto: esHowto }
};

// Register translations for the new locales
resources.hu = { translation: hu, howto: huHowto };
resources.nl = { translation: nl, howto: nlHowto };
resources.ru = { translation: ru, howto: ruHowto };
resources.sl = { translation: sl, howto: slHowto };

if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      fallbackLng: 'en',
      supportedLngs: supportedLanguages.map((lang) => lang.value),
      defaultNS: 'translation',
      interpolation: { escapeValue: false },
      detection: {
        order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
        caches: ['localStorage']
      },
      returnNull: false,
      returnEmptyString: false
    })
    .catch((error) => {
      console.error('i18n initialization failed', error);
    });
}

export default i18n;
